// extracted by mini-css-extract-plugin
export default {"discountTag":"discountTag__fgfcO","mobile":"mobile__KSkFu","planCard":"planCard__+xkxi","cardShadow":"cardShadow__xsRkk"};